<div class="dsg-page">

  <div class="dsg-topbar">
    <div class="dsg-search">
      <span class="material-icons">search</span>
      <input type="text" placeholder="Search designations…" [(ngModel)]="search">
    </div>
    <button class="dsg-btn-primary" (click)="openDrawer()">
      <span class="material-icons">add</span> New Designation
    </button>
  </div>

  <div class="dsg-stats-row" *ngIf="!loading && mergedDesignations.length > 0">
    <div class="dsg-stat-card">
      <span class="dsg-stat-icon" style="background:rgba(51,65,85,.1);color:#334155">
        <span class="material-icons">badge</span>
      </span>
      <div class="dsg-stat-body">
        <div class="dsg-stat-val">{{ mergedDesignations.length }}</div>
        <div class="dsg-stat-lbl">Total Designations</div>
      </div>
    </div>
  </div>

  <div class="dsg-loading" *ngIf="loading">
    <div class="dsg-skel" *ngFor="let i of [1,2,3,4,5]"></div>
  </div>

  <div class="dsg-empty" *ngIf="!loading && filteredDesignations.length === 0">
    <span class="material-icons">badge</span>
    <p *ngIf="!search">No designations yet. Create your first job title.</p>
    <p *ngIf="search">No designations match "{{ search }}".</p>
    <button class="dsg-btn-primary" *ngIf="!search" (click)="openDrawer()">
      <span class="material-icons">add</span> New Designation
    </button>
  </div>

  <div class="dsg-table-wrap" *ngIf="!loading && filteredDesignations.length > 0">
    <table class="dsg-table">
      <thead>
        <tr>
          <th>Name</th>
          <th>Code</th>
          <th>Mail Alias</th>
          <th class="dsg-col-num">Associated Users</th>
          <th class="dsg-col-actions">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let d of filteredDesignations">
          <td>
            <div class="dsg-name">
              {{ d.name }}
              <span class="dsg-tag-unmanaged" *ngIf="d.unmanaged" title="Exists on employee records but not saved as a master designation">Unmanaged</span>
            </div>
            <div class="dsg-desc" *ngIf="d.description">{{ d.description }}</div>
          </td>
          <td><span class="dsg-code" *ngIf="d.code">{{ d.code }}</span><span class="dsg-muted" *ngIf="!d.code">—</span></td>
          <td><span *ngIf="d.mailAlias">{{ d.mailAlias }}</span><span class="dsg-muted" *ngIf="!d.mailAlias">—</span></td>
          <td class="dsg-col-num">
            <span class="dsg-count">{{ getEmployeeCount(d) }}</span>
          </td>
          <td class="dsg-col-actions">
            <button class="dsg-act-btn dsg-act-add" *ngIf="d.unmanaged" (click)="openDrawer(d)" title="Add to master">
              <span class="material-icons">playlist_add</span>
            </button>
            <ng-container *ngIf="!d.unmanaged">
              <button class="dsg-act-btn" (click)="openDrawer(d)" title="Edit">
                <span class="material-icons">edit</span>
              </button>
              <button class="dsg-act-btn dsg-act-del" (click)="deleteDesignation(d)" title="Delete">
                <span class="material-icons">delete_outline</span>
              </button>
            </ng-container>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

</div>

<div class="dsg-overlay" *ngIf="drawerOpen" (click)="closeDrawer()"></div>
<div class="dsg-drawer" [class.open]="drawerOpen">
  <div class="dsg-drawer-header">
    <div class="dsg-drawer-title-row">
      <div class="dsg-drawer-title-icon"><span class="material-icons">badge</span></div>
      <div>
        <div class="dsg-drawer-title">{{ editingId ? 'Edit Designation' : 'New Designation' }}</div>
        <div class="dsg-drawer-sub">Job title master record</div>
      </div>
    </div>
    <button class="dsg-drawer-close" (click)="closeDrawer()"><span class="material-icons">close</span></button>
  </div>

  <div class="dsg-drawer-body">
    <div class="dsg-field">
      <label class="dsg-label">Name <span class="req">*</span></label>
      <input class="dsg-input" type="text" placeholder="e.g. Senior Consultant" [(ngModel)]="form.name">
    </div>

    <div class="dsg-field">
      <label class="dsg-label">Code <span class="dsg-hint">(optional)</span></label>
      <input class="dsg-input" type="text" placeholder="e.g. SC" [(ngModel)]="form.code">
    </div>

    <div class="dsg-field">
      <label class="dsg-label">Mail Alias <span class="dsg-hint">(optional)</span></label>
      <input class="dsg-input" type="text" placeholder="e.g. seniors@company.com" [(ngModel)]="form.mailAlias">
    </div>

    <div class="dsg-field">
      <label class="dsg-label">Description <span class="dsg-hint">(optional)</span></label>
      <textarea class="dsg-input dsg-textarea" rows="3" placeholder="Short description…" [(ngModel)]="form.description"></textarea>
    </div>
  </div>

  <div class="dsg-drawer-footer">
    <button class="dsg-btn-outline" (click)="closeDrawer()">Cancel</button>
    <button class="dsg-btn-primary" (click)="submit()" [disabled]="submitting">
      {{ submitting ? 'Saving…' : (editingId ? 'Save Changes' : 'Create') }}
    </button>
  </div>
</div>
